<template>
	<div class="grid-view" :style="_style">
		<slot />
	</div>
</template>

<script>
	export default {
		props: {
			rows: {
				type: Array,
				default() {
					return ['auto'];
				}
			},
			cols: {
				type: Array,
				default() {
					return ['auto'];
				}
			}
		},
		computed: {
			_style() {
				return {
					'grid-template-columns':	this.cols.join(' '),
					'grid-template-rows':		this.rows.join(' ')
				};
			}
		}
	}
</script>

<style lang="scss" scoped>
	.grid-view {
		display: 	grid;
		row-gap: 	10px;
		column-gap: 10px;

		& > * {
			width: 100% ! important;
		}
	}
</style>